import React, { Component } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import Alert from "react-s-alert";
import { Panel, Button } from "react-bootstrap";
import AuthContext from "../auth-context";
import Pagination from "../Shared/pagination";
import SalesPersonTasksService from "../utils/SalesPersonTasksService";
import TaskDetailModal from "./TaskDetailModal";
import AssignTaskModal from "./AssignTaskModal";
import SendTaskSmsModal from "./SendTaskSmsModal";
import BulkNoSaleModal from "./BulkNoSaleModal";

class List extends Component {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    const authStore = this.context;
    this.isAdmin = authStore.hasRole("admin");
    this.isRestrictedCoach = authStore.hasRole("coach_restricted");
    
    this.state = {
      users: props.users || [],
      filter: {
        assignee_id: "",
        type: "",
        include_overdue_sales: true
      },
      showDetailModal: false,
      selectedTask: null,
      showAssignModal: false,
      taskToAssign: null,
      selectedTasksById: {},
      recentlySentDealIds: [],
      showSmsModal: false,
      showNoSaleModal: false,
      loadingInProgress: false,
      actionInProgress: false,
      availableTypes: [],
      groupBy: this.isAdmin ? "user" : "date",
      // Section states
      sections: {
        overdue: { expanded: false, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false },
        today: { expanded: true, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false },
        tomorrow: { expanded: false, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false },
        thisWeek: { expanded: false, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false },
        nextWeek: { expanded: false, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false },
        upcoming: { expanded: false, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false },
        done: { expanded: false, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false },
        approved: { expanded: false, currentPage: 1, totalPages: 1, tasks: [], totalCount: 0, loading: false }
      },
      userSections: {}, // Dynamic sections for each user
      perPage: 10
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleViewTask = this.handleViewTask.bind(this);
    this.handleDeleteTask = this.handleDeleteTask.bind(this);
    this.handleDetailModalClose = this.handleDetailModalClose.bind(this);
    this.handleAssignTask = this.handleAssignTask.bind(this);
    this.handleAssignModalClose = this.handleAssignModalClose.bind(this);
    this.handleAssignComplete = this.handleAssignComplete.bind(this);
    this.toggleSection = this.toggleSection.bind(this);
    this.handleSectionPageChange = this.handleSectionPageChange.bind(this);
    this.handleGroupByChange = this.handleGroupByChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleToggleTask = this.handleToggleTask.bind(this);
    this.handleToggleAll = this.handleToggleAll.bind(this);
    this.handleClearSelection = this.handleClearSelection.bind(this);
    this.handleBulkComplete = this.handleBulkComplete.bind(this);
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    this.fetchOptions();
    if (this.state.groupBy === "date") {
      this.fetchSectionsSummary();
      this.fetchAllSections();
    } else {
      this.fetchUserSections();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.users !== prevProps.users) {
      this.setState({ users: this.props.users });
    }
  }

  fetchOptions() {
    SalesPersonTasksService.getOptions()
      .then(data => {
        this.setState({
          availableTypes: data.types || []
        });
      })
      .catch(error => {
        console.error("Failed to load options:", error);
      });
  }

  fetchSectionsSummary() {
    SalesPersonTasksService.getSectionsSummary(this.state.filter)
      .then(data => {
        const sections = { ...this.state.sections };
        Object.keys(data).forEach(key => {
          if (sections[key]) {
            sections[key].totalCount = data[key];
            sections[key].totalPages = Math.ceil(data[key] / this.state.perPage) || 1;
          }
        });
        this.setState({ sections });
      })
      .catch(error => {
        console.error("Failed to load sections summary:", error);
      });
  }

  fetchAllSections() {
    const sectionKeys = ['overdue', 'today', 'tomorrow', 'thisWeek', 'nextWeek', 'upcoming', 'done', 'approved'];
    sectionKeys.forEach(key => {
      this.fetchSectionTasks(key, this.state.sections[key].currentPage);
    });
  }

  fetchSectionTasks(sectionKey, page = 1) {
    const sections = { ...this.state.sections };
    sections[sectionKey].loading = true;
    this.setState({ sections });

    // Map frontend section keys to backend section names
    const sectionMap = {
      overdue: 'overdue',
      today: 'today',
      tomorrow: 'tomorrow',
      thisWeek: 'this_week',
      nextWeek: 'next_week',
      upcoming: 'upcoming',
      done: 'done',
      approved: 'approved'
    };

    SalesPersonTasksService.index({
      ...this.state.filter,
      section: sectionMap[sectionKey],
      page: page,
      per: this.state.perPage
    }).then(data => {
      const updatedSections = { ...this.state.sections };
      updatedSections[sectionKey] = {
        ...updatedSections[sectionKey],
        tasks: data.results || [],
        totalCount: data.total_count || 0,
        totalPages: Math.ceil((data.total_count || 0) / this.state.perPage) || 1,
        currentPage: page,
        loading: false
      };
      this.setState({ 
        sections: updatedSections,
        loadingInProgress: false 
      });
    }).catch(error => {
      console.error(`Error fetching ${sectionKey} tasks:`, error);
      const updatedSections = { ...this.state.sections };
      updatedSections[sectionKey].loading = false;
      this.setState({ 
        sections: updatedSections,
        loadingInProgress: false 
      });
    });
  }

  toggleSection(sectionKey) {
    const sections = { ...this.state.sections };
    sections[sectionKey].expanded = !sections[sectionKey].expanded;
    this.setState({ sections });
  }

  handleSectionPageChange(sectionKey, newPage) {
    this.fetchSectionTasks(sectionKey, newPage);
  }

  handleFilterChange(event) {
    const filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter, selectedTasksById: {} }, () => {
      if (this.state.groupBy === "date") {
        this.fetchSectionsSummary();
        this.fetchAllSections();
      } else {
        this.fetchUserSections();
      }
    });
  }

  handleGroupByChange(event) {
    const groupBy = event.target.value;
    this.setState({ groupBy, loadingInProgress: true, selectedTasksById: {} }, () => {
      if (groupBy === "date" || groupBy === "status") {
        this.fetchSectionsSummary();
        this.fetchAllSections();
      } else {
        this.fetchUserSections();
      }
    });
  }

  fetchUserSections() {
    // Get all tasks grouped by user, sorted by due date (overdue first)
    SalesPersonTasksService.index({
      ...this.state.filter,
      page: 1,
      per: 1000 // Get all tasks for grouping
    }).then(data => {
      const tasks = data.results || [];
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      // Group tasks by user
      const userGroups = {};
      tasks.forEach(task => {
        const userId = task.assignee_id || 'unassigned';
        const userName = task.assignee_name || 'Unassigned';
        const userRegion = task.assignee_id ? this.getUserRegion(task.assignee_id) : '';
        const displayName = userRegion ? `${userName} - ${userRegion}` : userName;
        
        if (!userGroups[userId]) {
          userGroups[userId] = {
            name: displayName,
            tasks: [],
            expanded: false,
            totalCount: 0,
            overdueCount: 0,
            onHoldCount: 0
          };
        }
        userGroups[userId].tasks.push(task);
        
        // Count overdue tasks (due date in the past, excluding done/approved tasks)
        if (task.due_date && task.status !== 'approved' && task.status !== 'done_by_sales_rep') {
          const dueDate = new Date(task.due_date);
          dueDate.setHours(0, 0, 0, 0);
          if (dueDate < today) {
            userGroups[userId].overdueCount++;
          }
        }
        
        // Count on-hold tasks (type is "On Hold")
        if (task.type === 'On Hold') {
          userGroups[userId].onHoldCount++;
        }
      });
      
      // Sort tasks within each user group by due date (overdue first, then by date)
      Object.keys(userGroups).forEach(userId => {
        userGroups[userId].tasks.sort((a, b) => {
          // Tasks without due date go to the end
          if (!a.due_date && !b.due_date) return 0;
          if (!a.due_date) return 1;
          if (!b.due_date) return -1;
          
          // Sort by due date ascending (oldest/most overdue first)
          return new Date(a.due_date) - new Date(b.due_date);
        });
        userGroups[userId].totalCount = userGroups[userId].tasks.length;
      });
      
      this.setState({ 
        userSections: userGroups,
        loadingInProgress: false 
      });
    }).catch(error => {
      console.error("Error fetching user sections:", error);
      this.setState({ loadingInProgress: false });
    });
  }

  refreshTasks() {
    if (this.state.groupBy === "date" || this.state.groupBy === "status") {
      this.fetchSectionsSummary();
      this.fetchAllSections();
    } else {
      this.fetchUserSections();
    }
  }

  isTaskSelectable(task) {
    return this.isAdmin && task.type === "Sales Overdue" && !!task.deal_id;
  }

  selectedTasks() {
    return Object.keys(this.state.selectedTasksById).map(id => this.state.selectedTasksById[id]);
  }

  isTaskSelected(task) {
    return !!this.state.selectedTasksById[task.id];
  }

  handleToggleTask(task) {
    const selectedTasksById = { ...this.state.selectedTasksById };
    if (selectedTasksById[task.id]) {
      delete selectedTasksById[task.id];
    } else {
      selectedTasksById[task.id] = task;
    }
    this.setState({ selectedTasksById });
  }

  handleToggleAll(tasks) {
    const selectable = (tasks || []).filter(task => this.isTaskSelectable(task));
    if (selectable.length === 0) return;

    const selectedTasksById = { ...this.state.selectedTasksById };
    const deselecting = selectable.every(task => selectedTasksById[task.id]);

    selectable.forEach(task => {
      if (deselecting) {
        delete selectedTasksById[task.id];
      } else {
        selectedTasksById[task.id] = task;
      }
    });

    this.setState({ selectedTasksById });
  }

  handleClearSelection() {
    this.setState({ selectedTasksById: {} });
  }

  handleBulkComplete(sentDealIds) {
    const recentlySentDealIds = this.state.recentlySentDealIds.concat(
      (sentDealIds || []).filter(id => !this.state.recentlySentDealIds.includes(id))
    );

    this.setState({
      selectedTasksById: {},
      showSmsModal: false,
      showNoSaleModal: false,
      recentlySentDealIds
    });
    this.refreshTasks();
  }

  getUserRegion(userId) {
    const user = this.state.users.find(u => u.id === parseInt(userId));
    return user ? user.region : '';
  }

  getUserNameWithRegion(task) {
    if (!task.assignee_name) return '';
    const region = task.assignee_id ? this.getUserRegion(task.assignee_id) : '';
    return region ? `${task.assignee_name} - ${region}` : task.assignee_name;
  }

  handleCheckboxChange(event) {
    const filter = { ...this.state.filter };
    filter[event.target.id] = event.target.checked;
    this.setState({ filter, selectedTasksById: {} }, () => {
      if (this.state.groupBy === "date") {
        this.fetchSectionsSummary();
        this.fetchAllSections();
      } else {
        this.fetchUserSections();
      }
    });
  }

  handleViewTask(task) {
    this.setState({ showDetailModal: true, selectedTask: task });
  }

  handleDeleteTask(taskId) {
    if (this.isRestrictedCoach && !this.isAdmin) {
      Alert.error("You do not have permission to delete tasks");
      return;
    }

    if (!window.confirm("Are you sure you want to delete this task?")) {
      return;
    }

    this.setState({ actionInProgress: true });
    SalesPersonTasksService.delete(taskId)
      .then(() => {
        Alert.success("Task deleted successfully");
        if (this.state.groupBy === "date") {
          this.fetchSectionsSummary();
          this.fetchAllSections();
        } else {
          this.fetchUserSections();
        }
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.error 
          ? error.response.data.error 
          : "Failed to delete task";
        Alert.error(errorMsg);
      })
      .finally(() => {
        this.setState({ actionInProgress: false });
      });
  }

  handleDetailModalClose() {
    this.setState({ showDetailModal: false, selectedTask: null });
    if (this.state.groupBy === "date" || this.state.groupBy === "status") {
      this.fetchSectionsSummary();
      this.fetchAllSections();
    } else {
      this.fetchUserSections();
    }
  }

  handleAssignTask(task) {
    this.setState({ showAssignModal: true, taskToAssign: task });
  }

  handleAssignModalClose() {
    this.setState({ showAssignModal: false, taskToAssign: null });
  }

  handleAssignComplete(updatedTask) {
    this.setState({ showAssignModal: false, taskToAssign: null });
    if (this.state.groupBy === "date" || this.state.groupBy === "status") {
      this.fetchSectionsSummary();
      this.fetchAllSections();
    } else {
      this.fetchUserSections();
    }
  }

  handleStatusChange(taskId, newStatus) {
    // Prevent non-admins from setting status to "approved"
    if (newStatus === "approved" && !this.isAdmin) {
      Alert.error("Only admins can approve tasks");
      return;
    }

    this.setState({ actionInProgress: true });
    SalesPersonTasksService.update(taskId, { status: newStatus })
      .then(() => {
        Alert.success("Status updated successfully");
        if (this.state.groupBy === "date" || this.state.groupBy === "status") {
          this.fetchSectionsSummary();
          this.fetchAllSections();
        } else {
          this.fetchUserSections();
        }
      })
      .catch(error => {
        const errorMsg = error.response && error.response.data && error.response.data.error 
          ? error.response.data.error 
          : "Failed to update status";
        Alert.error(errorMsg);
      })
      .finally(() => {
        this.setState({ actionInProgress: false });
      });
  }

  getTypeBadgeClass(type) {
    if (!type) return "default";
    
    // Normalize type for comparison (lowercase, replace spaces/hyphens with underscores)
    const normalizedType = type.toLowerCase().replace(/[\s-]+/g, '_');
    
    // Only 2 system types with predefined colors
    const systemTypes = {
      incomplete_sale: "danger",
      sales_overdue: "danger"
    };
    
    if (systemTypes[normalizedType]) {
      return systemTypes[normalizedType];
    }
    
    // For all other types, use 2-3 colors randomly
    const colors = ["primary", "info", "success"];
    const hash = type.split('').reduce((acc, char) => {
      return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);
    const index = Math.abs(hash) % colors.length;
    
    return colors[index];
  }

  getStatusBadgeClass(status) {
    const statusMap = {
      to_do: "default",
      done_by_sales_rep: "info",
      approved: "success"
    };
    return statusMap[status] || "default";
  }

  getStatusLabel(status) {
    const statusLabels = {
      to_do: "To Do",
      done_by_sales_rep: "Done by Sales Rep",
      approved: "Approved"
    };
    return statusLabels[status] || "To Do";
  }

  render() {
    const titleCase = str => {
      if (!str) return str;
      return str.replace(/_/g, " ").replace(/\w\S*/g, txt => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };

    const selectableIds = tasks =>
      (tasks || []).filter(task => this.isTaskSelectable(task)).map(task => task.id);

    const allSelected = tasks =>
      selectableIds(tasks).every(id => !!this.state.selectedTasksById[id]);

    const selectedTasks = this.selectedTasks();

    const TaskRow = ({ task, showAssignee = true, showSelect = false }) => {
      const isOverdue = task.is_overdue;
      const isSalesOverdue = task.type === 'Sales Overdue';
      const taskTitle = isSalesOverdue && task.deal_contact_name
        ? `Overdue Sale - ${task.deal_contact_name}` 
        : task.title;

      const selectable = this.isTaskSelectable(task);
      const waitlistSmsDaysAgo =
        task.waitlist_sms_days_ago !== null && task.waitlist_sms_days_ago !== undefined
          ? task.waitlist_sms_days_ago
          : task.type === "Sales Overdue" && this.state.recentlySentDealIds.includes(task.deal_id)
          ? 0
          : null;

      return (
        <tr>
          {showSelect && (
            <td style={{ textAlign: "center" }}>
              {selectable && (
                <input
                  type="checkbox"
                  checked={this.isTaskSelected(task)}
                  onChange={() => this.handleToggleTask(task)}
                />
              )}
            </td>
          )}
          <td>#{task.id}</td>
          <td>
            <strong>{taskTitle}</strong>
            {waitlistSmsDaysAgo !== null && (
              <div style={{ marginTop: 4 }}>
                <span className="label label-info" title="48hr hold waitlist SMS sent to this deal">
                  <i className="fa fa-comment" style={{ marginRight: 4 }} />
                  Waitlist SMS sent{" "}
                  {waitlistSmsDaysAgo === 0 ? "today" : `${waitlistSmsDaysAgo}d ago`}
                </span>
              </div>
            )}
          </td>
          <td>
            {task.due_date ? (
              <Moment format="MMM DD, YYYY">{task.due_date}</Moment>
            ) : (
              <span className="text-muted">No due date</span>
            )}
          </td>
          <td>
            <span className={`label label-${this.getTypeBadgeClass(task.type)}`}>
              {task.type ? titleCase(task.type) : <span style={{ color: "white" }}>No type</span>}
            </span>
          </td>
          <td>
            <div style={{ position: "relative", display: "inline-block" }}>
              <select
                value={task.status}
                onChange={(e) => this.handleStatusChange(task.id, e.target.value)}
                disabled={this.state.actionInProgress}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  backgroundColor: this.getStatusBadgeClass(task.status) === "default" ? "#777" : 
                                   this.getStatusBadgeClass(task.status) === "info" ? "#5bc0de" : "#5cb85c",
                  color: "white",
                  border: "none",
                  borderRadius: "3px",
                  padding: "4px 24px 4px 8px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  outline: "none",
                  minWidth: "140px"
                }}
              >
                <option value="to_do">To Do</option>
                <option value="done_by_sales_rep">Done by Sales Rep</option>
                {this.isAdmin && <option value="approved">Approved</option>}
              </select>
              <i 
                className="fa fa-caret-down" 
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "white",
                  fontSize: "14px"
                }}
              />
            </div>
          </td>
          {showAssignee && this.isAdmin && (
            <td>
              {task.assignee_name ? (
                <span
                  onClick={() => this.handleAssignTask(task)}
                  className="btn-link"
                  style={{ cursor: "pointer" }}
                  title="Click to change assignee"
                >
                  {this.getUserNameWithRegion(task)}
                </span>
              ) : (
                <Button
                  bsStyle="info"
                  bsSize="xs"
                  onClick={() => this.handleAssignTask(task)}
                >
                  Assign
                </Button>
              )}
            </td>
          )}
          <td>
            {task.deal_id && (
              <>
                <Link to={`/m1/deals/${task.deal_id}`}>Deal #{task.deal_id}</Link>
                {task.deal_contact_name && <div className="text-muted" style={{ fontSize: "12px" }}>{task.deal_contact_name}</div>}
              </>
            )}
          </td>
          <td style={{ textAlign: "center" }}>
            {task.days_overdue > 0 ? (
              <span>{task.days_overdue}</span>
            ) : (
              <span className="text-muted">-</span>
            )}
          </td>
          <td style={{ textAlign: "center" }}>
            <span className="badge" style={{ backgroundColor: task.comments_count > 0 ? "#5bc0de" : "#999" }}>
              {task.comments_count || 0}
            </span>
          </td>
          <td style={{ whiteSpace: "nowrap" }}>
            <i
              className="fa fa-pencil"
              onClick={() => this.handleViewTask(task)}
              style={{
                cursor: "pointer",
                fontSize: "16px",
                marginRight: "12px"
              }}
              title="Edit task"
            />
            {this.isAdmin && !isSalesOverdue && (
              <i
                className="fa fa-trash"
                onClick={() => this.handleDeleteTask(task.id)}
                style={{
                  cursor: "pointer",
                  fontSize: "16px"
                }}
                title="Delete task"
              />
            )}
          </td>
        </tr>
      );
    };

    const TaskSection = ({ sectionKey, title }) => {
      const section = this.state.sections[sectionKey];
      const count = section.totalCount || 0;
      const hasSelectable = selectableIds(section.tasks).length > 0;

      return (
        <Panel 
          bsStyle="default"
          expanded={section.expanded}
          onToggle={() => {}}
          style={{ marginBottom: "15px" }}
        >
          <Panel.Heading 
            onClick={() => this.toggleSection(sectionKey)}
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            <Panel.Title>
              <i className={`fa fa-chevron-${section.expanded ? 'down' : 'right'}`} style={{ marginRight: "10px" }}></i>
              {title} ({count})
            </Panel.Title>
          </Panel.Heading>
          {section.expanded && (
            <Panel.Body style={{ padding: 0 }}>
              {count > 0 ? (
                <>
                  <table className="table table-hover table-bordered" style={{ marginBottom: 0 }}>
                    <thead className="dark">
                      <tr>
                        {hasSelectable && (
                          <th style={{ width: 30, textAlign: "center" }}>
                            <input
                              type="checkbox"
                              checked={allSelected(section.tasks)}
                              onChange={() => this.handleToggleAll(section.tasks)}
                            />
                          </th>
                        )}
                        <th style={{ width: 10 }}>ID</th>
                        <th>Title</th>
                        <th>Due Date</th>
                        <th>Type</th>
                        <th>Status</th>
                        {this.isAdmin && <th>Assignee</th>}
                        <th>Deal</th>
                        <th style={{ width: 100 }}>Days Overdue</th>
                        <th style={{ width: 80 }}>Comments</th>
                        <th style={{ width: 150 }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {section.tasks.map(task => (
                        <TaskRow key={task.id} task={task} showSelect={hasSelectable} />
                      ))}
                    </tbody>
                  </table>
                  {section.totalPages > 1 && (
                    <div style={{ padding: "10px", textAlign: "center", borderTop: "1px solid #ddd" }}>
                      <Pagination
                        currentPage={section.currentPage}
                        totalPages={section.totalPages}
                        onChange={(page) => this.handleSectionPageChange(sectionKey, page)}
                      />
                    </div>
                  )}
                </>
              ) : (
                <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
                  No tasks in this section
                </div>
              )}
            </Panel.Body>
          )}
        </Panel>
      );
    };

    return (
      <div>
        <div className="row" style={{ marginBottom: "10px" }}>
          <div className="col-sm-12">
            {this.isAdmin && (
              <>
                <select
                  style={{ padding: "6px 12px", borderRadius: "4px", border: "1px solid #ccc", marginRight: 10 }}
                  id="type"
                  value={this.state.filter.type}
                  onChange={this.handleFilterChange}
                >
                  <option value="">(all types)</option>
                  {this.state.availableTypes.map(type => (
                    <option key={type} value={type}>
                      {titleCase(type)}
                    </option>
                  ))}
                </select>

                <select
                  style={{ padding: "6px 12px", borderRadius: "4px", border: "1px solid #ccc", marginRight: 10 }}
                  id="assignee_id"
                  value={this.state.filter.assignee_id}
                  onChange={this.handleFilterChange}
                >
                  <option value="">(all assignees)</option>
                  {this.state.users
                    .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                    .map(user => (
                      <option key={user.id} value={user.id}>
                        {user.name}
                      </option>
                    ))}
                </select>

                <label style={{ display: "inline-flex", alignItems: "center", gap: "5px", marginLeft: "10px" }}>
                  <input
                    type="checkbox"
                    id="include_overdue_sales"
                    checked={this.state.filter.include_overdue_sales}
                    onChange={this.handleCheckboxChange}
                  />
                  <span>Include Overdue Sales</span>
                </label>

                <select
                  style={{ padding: "6px 12px", borderRadius: "4px", border: "1px solid #ccc", marginLeft: 10 }}
                  value={this.state.groupBy}
                  onChange={this.handleGroupByChange}
                >
                  <option value="date">Group by Date</option>
                  <option value="user">Group by User</option>
                  <option value="status">Group by Status</option>
                </select>
              </>
            )}
          </div>
        </div>

        {this.isAdmin && selectedTasks.length > 0 && (
          <div className="row" style={{ marginBottom: "10px" }}>
            <div className="col-sm-12">
              <div
                style={{
                  background: "#f5f5f5",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <strong style={{ marginRight: 15 }}>
                  {selectedTasks.length} task{selectedTasks.length === 1 ? "" : "s"} selected
                </strong>
                <Button
                  bsStyle="info"
                  bsSize="small"
                  style={{ marginRight: 10 }}
                  onClick={() => this.setState({ showSmsModal: true })}
                >
                  <i className="fa fa-comment" style={{ marginRight: 5 }} />
                  Send Waitlist SMS
                </Button>
                <Button
                  bsStyle="danger"
                  bsSize="small"
                  style={{ marginRight: 10 }}
                  onClick={() => this.setState({ showNoSaleModal: true })}
                >
                  Mark as No Sale
                </Button>
                <Button bsSize="small" onClick={this.handleClearSelection}>
                  Clear
                </Button>
              </div>
            </div>
          </div>
        )}

        {this.state.loadingInProgress ? (
          <div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>
        ) : this.state.groupBy === "date" ? (
          <div>
            <TaskSection sectionKey="overdue" title="Overdue" />
            <TaskSection sectionKey="today" title="Today" />
            <TaskSection sectionKey="tomorrow" title="Tomorrow" />
            <TaskSection sectionKey="thisWeek" title="This Week" />
            <TaskSection sectionKey="nextWeek" title="Next Week" />
            <TaskSection sectionKey="upcoming" title="Upcoming" />
            <TaskSection sectionKey="done" title="Done" />
            <TaskSection sectionKey="approved" title="Approved" />
          </div>
        ) : this.state.groupBy === "status" ? (
          <div>
            <TaskSection sectionKey="done" title="Done" />
            <TaskSection sectionKey="approved" title="Approved" />
          </div>
        ) : (
          <div>
            {Object.keys(this.state.userSections).length > 0 ? (
              Object.keys(this.state.userSections)
                .sort((a, b) => {
                  const nameA = this.state.userSections[a].name;
                  const nameB = this.state.userSections[b].name;
                  // Put "Unassigned" at the end
                  if (nameA === "Unassigned") return 1;
                  if (nameB === "Unassigned") return -1;
                  return nameA.localeCompare(nameB);
                })
                .map(userId => {
                  const userSection = this.state.userSections[userId];
                  const hasSelectable = selectableIds(userSection.tasks).length > 0;
                  return (
                    <Panel 
                      key={userId}
                      bsStyle="default"
                      expanded={userSection.expanded}
                      onToggle={() => {}}
                      style={{ marginBottom: "15px" }}
                    >
                      <Panel.Heading 
                        onClick={() => {
                          const userSections = { ...this.state.userSections };
                          userSections[userId].expanded = !userSections[userId].expanded;
                          this.setState({ userSections });
                        }}
                        style={{ cursor: "pointer", userSelect: "none" }}
                      >
                        <Panel.Title>
                          <i className={`fa fa-chevron-${userSection.expanded ? 'down' : 'right'}`} style={{ marginRight: "10px" }}></i>
                          {userSection.name} ({userSection.totalCount})
                          <span style={{ color: userSection.overdueCount > 0 ? "#d9534f" : "#999", marginLeft: "10px", fontWeight: "normal" }}>
                            {userSection.overdueCount} overdue
                          </span>
                          {userSection.onHoldCount > 0 && (
                            <span style={{ color: "#5bc0de", marginLeft: "10px", fontWeight: "normal" }}>
                              {userSection.onHoldCount} On Hold
                            </span>
                          )}
                        </Panel.Title>
                      </Panel.Heading>
                      {userSection.expanded && (
                        <Panel.Body style={{ padding: 0 }}>
                          {userSection.totalCount > 0 ? (
                            <table className="table table-hover table-bordered" style={{ marginBottom: 0 }}>
                              <thead className="dark">
                                <tr>
                                  {hasSelectable && (
                                    <th style={{ width: 30, textAlign: "center" }}>
                                      <input
                                        type="checkbox"
                                        checked={allSelected(userSection.tasks)}
                                        onChange={() => this.handleToggleAll(userSection.tasks)}
                                      />
                                    </th>
                                  )}
                                  <th style={{ width: 10 }}>ID</th>
                                  <th>Title</th>
                                  <th>Due Date</th>
                                  <th>Type</th>
                                  <th>Status</th>
                                  {this.isAdmin && <th>Assignee</th>}
                                  <th>Deal</th>
                                  <th style={{ width: 100 }}>Days Overdue</th>
                                  <th style={{ width: 80 }}>Comments</th>
                                  <th style={{ width: 150 }}>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {userSection.tasks.map(task => (
                                  <TaskRow
                                    key={task.id}
                                    task={task}
                                    showAssignee={this.isAdmin}
                                    showSelect={hasSelectable}
                                  />
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
                              No tasks for this user
                            </div>
                          )}
                        </Panel.Body>
                      )}
                    </Panel>
                  );
                })
            ) : (
              <div style={{ textAlign: "center", padding: "50px", color: "#999" }}>
                No tasks found
              </div>
            )}
          </div>
        )}

        {this.state.showDetailModal && (
          <TaskDetailModal
            task={this.state.selectedTask}
            isAdmin={this.isAdmin}
            users={this.state.users}
            onClose={this.handleDetailModalClose}
          />
        )}

        {this.state.showSmsModal && (
          <SendTaskSmsModal
            show={this.state.showSmsModal}
            tasks={selectedTasks}
            onClose={() => this.setState({ showSmsModal: false })}
            onSent={this.handleBulkComplete}
          />
        )}

        {this.state.showNoSaleModal && (
          <BulkNoSaleModal
            show={this.state.showNoSaleModal}
            tasks={selectedTasks}
            onClose={() => this.setState({ showNoSaleModal: false })}
            onComplete={this.handleBulkComplete}
          />
        )}

        {this.state.showAssignModal && (
          <AssignTaskModal
            show={this.state.showAssignModal}
            task={this.state.taskToAssign}
            users={this.state.users}
            onClose={this.handleAssignModalClose}
            onAssign={this.handleAssignComplete}
          />
        )}
      </div>
    );
  }
}

export default List;
